export default __webpack_public_path__ + "static/partners-title-curating-84bbe8b2e1463a05e7e29f9a9e57ab60.svg";